export default {
  // Mathematical constants
  e: '2.71',
  pi: '3.14',
  sqrt2: '1.41',
  phi: '1.62',
  tau: '6.28',
  graham: '99999.99',
  avogadro: '999999.99',
  googolplex: '99999.99',
  googol: '99999.99',

  // Food and their emojis
  beer: '3.82',
  '🍺': '3.82',
  pizza: '9.00',
  '🍕': '9.00',
  coffee: '2.95',
  '☕️': '2.95',
  hamburger: '3.57',
  '🍔': '3.57',

  // Other
  '💰': (Math.random() * 80 + 20).toFixed(2),
  // chai
  חי: '18.00',
}
